import { render, staticRenderFns } from "./preview_modal_starkid.vue?vue&type=template&id=3661c823&scoped=true"
import script from "./preview_modal_starkid.vue?vue&type=script&lang=js"
export * from "./preview_modal_starkid.vue?vue&type=script&lang=js"
import style0 from "./preview_modal_starkid.vue?vue&type=style&index=0&id=3661c823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3661c823",
  null
  
)

export default component.exports